import React from 'react';
import { NcziMessage } from '../../../../graphql/graphql';
import { joinClasses } from '../../../../Utils/className.util';
import { FormattedDateTime } from '../../../../Components/FormattedDate';
import { STATUS_TRANSLATION } from '../NCZILoadingStatus/NCZILoadingStatus';
import Text from '../../../../Components/Base/Text/Text';

// @ts-ignore
import styles from './NcziQueueItem.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
  item: NcziMessage
}

const NcziQueueItem: React.FC<Props> = props => {
  const { item } = props;
  const { socketUrl } = useAppContext();

  const allowPrint = item.type && [
    'ZapisZaznamOVysetreni_v7',
    'ZapisPotvrdenieDPN_v1',
    'ZapisOckovanie',
    'ZapisReakcieNaOckovanie',
    'UlozPreskripcnyZaznam',
    'UlozPreskripcnyZaznam_v6'
  ].indexOf(item.type) !== -1;

  return (
    <div className={joinClasses([styles.wrapper, item.lastState !== 'offline' ? styles.unseen : ''])}>
      <div className={styles.date}><FormattedDateTime datetime={item.createdAt} /></div>
      <div className={styles.title}>{item.type}</div>
      {allowPrint && <div className={styles.text}><LinkButton title={'base.print'} theme={Theme.BLUE} href={socketUrl + '/nczi-print/message/' + item.id} /></div>}
      <div className={styles.text}><Text tx={item.lastState ? (STATUS_TRANSLATION[item.lastState] || '') : ''} /></div>
    </div>
  );
};

export default NcziQueueItem;
